<div class="row">
  <div class="col-12">
    <nb-tabset fullWidth>
      <nb-tab i18n-tabTitle="@@Plans" tabTitle="Plans">
        <app-plan-list></app-plan-list>
      </nb-tab>
    </nb-tabset>
  </div>
</div>
